import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronLeftIcon, HomeIcon } from '@heroicons/react/24/outline';
import { findNavigationTrail, navigationConfig } from '../navigation/navConfig';

function AppBreadcrumbs() {
  const location = useLocation();
  const trail = useMemo(
    () => findNavigationTrail(navigationConfig, location.pathname, location.search),
    [location.pathname, location.search]
  );

  if (!trail.length) return null;

  return (
    <nav className="flex min-w-0 flex-wrap items-center gap-1 text-xs text-slate-500" aria-label="مسیر صفحه">
      <Link to="/" className="inline-flex min-h-7 items-center gap-1 rounded-md px-1.5 font-semibold hover:bg-slate-100 hover:text-primary-700">
        <HomeIcon className="h-3.5 w-3.5" />
        خانه
      </Link>
      {trail.map((item, index) => {
        const isLast = index === trail.length - 1;
        return (
          <React.Fragment key={`${item.name}-${index}`}>
            <ChevronLeftIcon className="h-3.5 w-3.5 shrink-0 text-slate-300" />
            {isLast || !item.href ? (
              <span className="max-w-[260px] truncate rounded-md bg-primary-50 px-2 py-1 font-bold text-primary-700">{item.name}</span>
            ) : (
              <Link to={item.href} className="max-w-[220px] truncate rounded-md px-1.5 py-1 font-semibold hover:bg-slate-100 hover:text-primary-700">
                {item.name}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

export default AppBreadcrumbs;
